import { ChangeEvent } from "@mcleod/components";
import { AutogenLayoutFuelFundedVendor } from "./autogen/AutogenLayoutFuelFundedVendor";

export class FuelFundedVendor extends AutogenLayoutFuelFundedVendor {
    /**
     * Check if any advanced communication options have data
     */
    hasAdvancedOptionsData(): boolean {
        const proxyServer = (this as any).textboxProxyServer?.text;
        const connectionMode = (this as any).textboxConnectionMode?.text;
        const connectionType = (this as any).textboxConnectionType?.text;

        return !!(proxyServer || connectionMode || connectionType);
    }

    textboxCheckAPVoucherOnChange(event: ChangeEvent): void {
        this.setCheckFieldVisibility(event.newValue);
    }

    private setCheckFieldVisibility(apVoucherValue: string) {
        const showFields = apVoucherValue === "Manual" || apVoucherValue === "Regular";
        this.textboxCheckAPDivisonCode.setProps({ visible: showFields, required: showFields });
        this.textboxCheckVendorCode.setProps({ visible: showFields, required: showFields });
        this.textboxCheckGLAccount.setProps({ visible: showFields, required: showFields });
    }

    textboxFuelAPVoucherOnChange(event: ChangeEvent): void {
        this.setFuelFieldVisibility(event.newValue);
    }

    private setFuelFieldVisibility(apVoucherValue: string) {
        const showFields = apVoucherValue === "Manual" || apVoucherValue === "Regular";
        this.textboxFuelAPDivisionCode.setProps({ visible: showFields, required: showFields });
        this.textboxFuelAPVendorCode.setProps({ visible: showFields, required: showFields });
        this.textboxFuelGLAccount.setProps({ visible: showFields, required: showFields });
    }

    textboxCommunicationOnChange(event: ChangeEvent) {
        this.setCommFieldVisibility(event.newValue);
    }

    private setCommFieldVisibility(commMethod: string) {
        this.textboxLogin.visible = commMethod != "Local";
        this.textboxPassword.visible = commMethod != "Local";
        this.textboxServerName.visible = commMethod != "Local";
        this.textboxPort.visible = commMethod != "Local";
        this.textboxDirectory.visible = commMethod == "Local" || commMethod !== "HttpsConnection";
        this.panelAdvancedOptions.visible = ["Internet-sftp", "Internet-ftp"].includes(commMethod);
        const isAdvEnabled = this.panelAdvancedOptions.visible && this.switchCommAdvOptions.checked;
        this.panelAdvCommunication.visible = isAdvEnabled;
        if (isAdvEnabled) {
            // Proxy always for FTP/SFTP, Mode/Type only for FTP
            this.textboxProxyServer.visible = true;
            this.textboxConnectionMode.visible = commMethod === "Internet-ftp";
            this.textboxConnectionType.visible = commMethod === "Internet-ftp";
        }
    }

    textboxAccountCodeOnBlur(event: ChangeEvent): void {
        const vendorDescr = this.textboxCardProvider?.text || "";
        if (["EFS LLC"].includes(vendorDescr)) {
            this.activeRow.set("customer_id", this.activeRow.get("master_account"));
        }
    }

    // Listener for the switch to show/hide advanced communication options
    switchCommAdvOptionsOnChange(event: ChangeEvent) {
        this.panelAdvCommunication.visible = !!event.newValue;
        this.setCommFieldVisibility(this.textboxCommunication.selectedItem.displayValue);
    }

    /**
     * Handler for Restrict Tractor Hub Updates switch
     */
    switchHubUpdateOnChange(event: ChangeEvent) {
        const isRestricted = !!event.newValue;
        this.textboxFuelHubVariance.visible = isRestricted;
    }
}
